import React from 'react'
import { Card, Flex } from 'antd'
import Subtitle from './Subtitle'

const cardStyle = { width: '35em', textAlign: 'center' }

export default function Solution () {
  return (
    <>
      <Subtitle text={'Notre solution est'} />
      <Flex vertical gap='1em' align='center'>
        <Card style={cardStyle} variant='borderless'>
          <div style={{ height: '110px' }}>
            <img src="/images/securise.svg" title="Sécurisé" alt="symbole Sécurité" width={80} />
          </div>
          <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
            Sécurisée
          </div>
          Un espace automatisé et supervisé par nos équipes en temps réel.
        </Card>
        <Card style={cardStyle} variant='borderless' >
          <div style={{ height: '110px' }}>
            <img src="/images/facile-acces.svg" title="Symbole Facile d'accès" alt=" acile d'accès" width={80} />
          </div>
          <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
            Facile d&apos;accès
          </div>
          Un dispositif innovant ouvert 7/7,<br />
          pour un rendez-vous immédiat ou dans un proche délai
        </Card>
        <Card style={cardStyle} variant='borderless' >
          <div style={{ height: '110px' }}>
            <img src="/images/automatisee.svg" title="Automatisée" alt="Symbole Automatisée" width={80} />
          </div>
          <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
            Automatisée
          </div>
          Un espace où les patients peuvent se rendre en toute autonomie pour téléconsulter.
        </Card>
        <Card style={cardStyle} variant='borderless' >
          <div style={{ height: '110px' }}>
            <img src="/images/au-plus-pres.svg" title="Au plus près" alt="Symbole Au plus près" width={80} />
          </div>
          <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
            Au plus près
          </div>
          Une solution sans limite d&apos;implantation pour être au plus proche de chacun
        </Card>
        <Card style={cardStyle} variant='borderless' >
          <div style={{ height: '110px' }}>
            <img src="/images/100-francaise.svg" title="100% française" alt="Symbole 100% française" width={80} />
          </div>
          <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
            100% française
          </div>
          De l&apos;idée à la conception la Box Médicale est un produit Made in France.
        </Card>
        <Card style={cardStyle} variant='borderless' >
          <div style={{ height: '110px' }}>
            <img src="/images/hygienique.svg" title="Hygiénique" alt="Symbole Hygiénique" width={80} />
          </div>
          <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
            Hygiénique
          </div>
          L&apos;hygiène est centrale dans notre démarche avec une désinfection complète par UV-C.
        </Card>
        <Card style={cardStyle} variant='borderless' >
          <div style={{ height: '110px' }}>
            <img src="/images/confidentielle.svg" title="Confidentielle" alt="Symbole Confidentielle" width={80} />
          </div>
          <div style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '20px' }}>
            Confidentielle
          </div>
          L&apos;espace de soins est dédié et reste discret comme chez le praticien.
        </Card>
      </Flex>
    </>
  )
}
